module.exports = __webpack_public_path__ + "fonts/midnight-sans-st-12-black-pro.f63c90d.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/MidnightSans/midnight-sans-st-12-black-pro.ttf
// module id = 174
// module chunks = 245 246